import { render, staticRenderFns } from "./DatasetInfo.vue?vue&type=template&id=d33ae136&scoped=true"
import script from "./DatasetInfo.vue?vue&type=script&lang=js"
export * from "./DatasetInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33ae136",
  null
  
)

export default component.exports